import React from "react";
import {CALENDER_ICON, HOME_ICON } from "assets/constants/Icons";
import moment from 'moment';

const HomePage = () => {
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${HOME_ICON}`}></i> Home Page</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
          GenAI is changing the world, one domain at a time, whats yours?"
            
          </div>
        </div>
      )
    }
  </>);
}

export default HomePage;